module.exports = __webpack_public_path__ + "img/photo_2023-04-27 22.15.22.8003dddb.jpeg";